/**
 * Created by Christof Sander on 22.06.2016.
 */

const CONSTANTS = require('../../lib/constants')
const utils = require('../../lib/utils')

module.exports = {
	config: {
		isContainerComponent: true,
		decisionMaker: true,
		decisionComponentHandlesCancel: false, // is the decisionComponent allowed to handle cancel decisions.
		focusAble: true,
		focusPriority: 1000,
		preventKeyDownControls: false,
		delayDecision: 0, // delay in [ms] to wait after a button click has happened
		preventUserInteraction: false, // render modal without width to prevent user interaction as well as interference with other gui elements.
		// additionalClasses: [], // string or array of strings identifying css classes for main div container
		transition: {
			// empty => do not perform any movement animation
			// N || E || S || W => move-in (-out) from (to) this direction by delta.x or delta.y
			// N-E => move in from north and move out to east
			// hide() can be called with reversed = true which would move-out to in-position.
			// 	e.g. E-W would slide the modal in from right to center,
			// 		on submit the modal slides further from center to left,
			// 		on cancel the modal slides back from center to right.
			// direction: 'E-W',
			duration: .25, // how many seconds should the modal-window take to get the movement animation done
			modalDuration: .2, // how many seconds should the modal take to get from opacity = 0 to 1
			// delta: { // how much should the modal move in x- and y-direction on show / hide.
			// 	x: '100vw',
			// 	y: '100vh',
			// },
		},
	},

	model: {
		active: false,
		visible: false,

		// TODO: DOCS
		title: 'MAIN TITLE',
		// titleKey: 'i18next key',
		// subTitle: 'SUB TITLE',
		// subTitleKey: 'i18next key',

		offsetLevel: 0,
	},

	actions: {
		addButton: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND,
				selector: 'section.footer'
			}
		},
		loadContent: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML,
				selector: 'section.body'
			}
		}
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action(event){
				const self = event.data.component
				const keyCode = utils.keyboard.getKeyCode(event)

				if(self.config.preventKeyDownControls && (keyCode === 'enter' || keyCode === 'esc')) {
					event.stopImmediatePropagation()
					event.stopPropagation()
					event.preventDefault()
				} else if($(event.target).closest('button, textarea').length > 0 && keyCode === 'enter') {
					event.stopImmediatePropagation()
				} else {
					let positive = false
					switch(keyCode){
						case 'enter':
							positive = true
						case 'esc':
							let $useButton
							if(positive){
								if(($useButton = event.data.component.$.find('section.footer button.positive:visible')).length == 1){
									event.stopImmediatePropagation()
									$useButton.click()
									return false
								}
							}
							else {
								if(
									($useButton = event.data.component.$.find('section.footer button.negative:visible')).length == 1
									||
									($useButton = event.data.component.$.find('> .background')).length == 1
								){
									event.stopImmediatePropagation()
									$useButton.click()
								}
							}
							break
					}
				}
			}
		},

		decision: {
			type: 'click',
			selector: '.background, section.header button.close, section.footer button',
			async action(event) {
				const self = event.data.component

				if(self.config.delayDecision) {
					await utils.promise.delayed(self.config.delayDecision)
				}

				event.preventDefault()
				event.stopImmediatePropagation()
				self.processDecisionByButton(event.currentTarget)
			}
		}
	},

	methods: {
		async show(loadContentGranted = false, transitionConfig = {}){
			// load content if necessary
			if(loadContentGranted){
				try {
					await this.performAction('loadContent')
				} catch (error) {
					await this.hide()
					return
				}
			}

			if(!this.model.active){
				this.model.active = true
				this.$.addClass('active')
			}

			await this.animate(true, false, transitionConfig)

			if(loadContentGranted){
				this.triggerFind('modalAttached')
			}
		},

		async hide(reverse = false, transitionConfig = {}){
			await this.animate(false, reverse, transitionConfig)
			this.destroy()
		},

		async animate(animateIn = true, reverse = false, transitionConfig = {}){
			try {
				const wasVisible = !!this.model.visible
				this.model.visible = !!animateIn
				const usedTransitionConfig = {
					...(this.config.transition || {}),
					...(transitionConfig || {}),
				}

				const {direction} = usedTransitionConfig
				const duration = usedTransitionConfig.duration || .25
				const modalDuration = usedTransitionConfig.modalDuration || .1
				const delta = usedTransitionConfig.delta || {}
				let [from, to] = String(direction || '').split('-')
				if(from && !to){
					to = from
				}

				const $modal = this.$
				const $window = $modal.find('> .window')

				if($modal.length && $window.length){

					const animation = {
						modal: {
							start: {
								opacity: 0,
							},
							end: {
								opacity: 1,
							},
						},
						window: {
							delta: {
								x: delta.x || '100vw',
								y: delta.y || '100vh',
							},
							start: {
								x: 0,
								y: 0,
							},
							end: {
								x: 0,
								y: 0,
							},
						}
					}
					let windowAnimationChange = animation.window.start

					let position = from
					if(animateIn) {
						animation.modal.start.opacity = 0
						animation.modal.end.opacity = 1
						if(reverse){
							position = to
						}
					} else {
						animation.modal.start.opacity = 1
						animation.modal.end.opacity = 0
						animation.modal.end.delay = Math.max(0, duration - modalDuration)
						windowAnimationChange = animation.window.end
						position = to
						if(reverse){
							position = from
						}
					}

					let positionValid = true
					if(position === 'N'){
						windowAnimationChange.y = `-${animation.window.delta.y}`
					} else if(position === 'E'){
						windowAnimationChange.x = animation.window.delta.x
					} else if(position === 'S') {
						windowAnimationChange.y = animation.window.delta.y
					} else if(position === 'W') {
						windowAnimationChange.x = `-${animation.window.delta.x}`
					} else {
						positionValid = false
					}

					// if visibility does not change just do it.
					// this is useful in some cases like: a visible refresh should not animate in.
					if(wasVisible === this.model.visible){
						TweenMax.set(
							$modal,
							{...animation.modal.end}
						)
						if(positionValid){
							TweenMax.set(
								$window,
								{...animation.window.end}
							)
						}

						return
					}


					TweenMax.set(
						$modal,
						{...animation.modal.start}
					)
					if(positionValid){
						TweenMax.set(
							$window,
							{...animation.window.start}
						)
					}

					const done = utils.promise.newCustom(this)
					requestAnimationFrame(() => {
						try {
							let animationsDone = 0
							TweenMax.to(
								$modal,
								modalDuration,
								{
									...animation.modal.end,
									onOverwrite(){
										if(++animationsDone > 1){
											done.resolve()
										}
									},
									onComplete(){
										if(++animationsDone > 1){
											done.resolve()
										}
									},
								},
							)
							if(positionValid){
								TweenMax.to(
									$window,
									duration,
									{
										...animation.window.end,
										onOverwrite(){
											if(++animationsDone > 1){
												done.resolve()
											}
										},
										onComplete(){
											if(++animationsDone > 1){
												done.resolve()
											}
										},
									},
								)
							} else {
								animationsDone++
							}
						} catch (error) {
							console.error(error)
							done.resolve()
						}
					})

					await done
				}
			} catch (error) {
				console.error(error)
			}
		},

		/**
		 * @param decisionTriggerComponent		Component
		 * @param decisionType					string
		 * @param mode							string
		 * @param additionalDecisionOptions		object used to extend decision options
		 * @returns {boolean} true => decision processed via onDecisionPromise, false => decision processed via trigger or not at all
		 */
		processDecision(decisionTriggerComponent, decisionType, mode, additionalDecisionOptions = {}){
			if(decisionType){
				let triggerFound 		= false
				const decisionOptions 	= this.config.decisionOptions || {}
				decisionOptions.mode 	= mode

				const decisionData = {
					decisionType: 				decisionType,
					decisionComponent: 			this,
					decisionOptions: 			{
						...decisionOptions,
						...(additionalDecisionOptions || {})
					},
					decisionOrigin: 			this.getResourceRegisterContent('decisionOrigin', false) || {},
					decisionTriggerComponent: 	decisionTriggerComponent
				}

				const onDecisionPromise = this.getResourceRegisterContent('onDecisionPromise', false)
				if(onDecisionPromise){
					onDecisionPromise.resolve(decisionData)
					return true
				}

				if(this.config.decisionMaker){
					this.parent(function(parentComponent){
						if(utils.isFunction(parentComponent.hooks.onDecision)){
							triggerFound = true
							parentComponent.trigger('onDecision', decisionData)
						}
					})
				}

				if(!triggerFound){
					this.trigger('onDecision', decisionData)
				}
			}

			return false
		},

		processDecisionByButton(domButton, decisionTriggerComponent){
			if(domButton){
				this.processDecision(decisionTriggerComponent, domButton.dataset.fieldType, domButton.dataset.buttonMode)
			}
		},

		decide(positive, decisionComponent){
			let $useButton
			if(positive || positive === undefined){
				if(($useButton = this.$.find('section.footer button.positive:visible')).length == 1){
					this.processDecisionByButton($useButton[0], decisionComponent)
				}
			} else if(
				($useButton = this.$.find('section.footer button.negative:visible')).length == 1
				||
				($useButton = this.$.find('> .background')).length == 1
			){
				this.processDecisionByButton($useButton[0], decisionComponent)
			}
		},

		setOffsetLevel(offsetLevel = 0){
			this.model.offsetLevel = offsetLevel
			if(this.$.length > 0){
				this.$[0].style.setProperty('--offset-level', offsetLevel)
			}
		}
	},

	hooks: {
		include($element, options){
			$element.find('section.footer').append(
				this.include(
					'../form/elements/buttons',
					{
						formMapping: {
							buttons: this.model.buttons
						}
					}
				)
			)
		},

		async attach($element, options){
			await this.show(!options.refresh)
		},

		// fallback trigger
		async onDecision($element, options){
			if(
				(
					options.decisionType === 'decisionComponent'
					||
					(
						options.decisionType === 'cancel'
						&&
						this.config.decisionComponentHandlesCancel
					)

				)
				&& options.decisionComponent
			){
				if(options.decisionComponent.componentIndex != this.componentIndex){
					return options.decisionComponent.trigger('onDecision', options)
				}
				if(this.triggerFind('onDecision', options)){
					return
				}
			}

			if(this.config.decisionMaker){
				let parent
				this.parent(c => parent = c)

				if(utils.isFunction(parent.hooks.onDecision)){
					return parent.trigger('onDecision', options)
				}
			}

			if(options.decisionType === 'cancel' || options.decisionType === 'close' || options.decisionType === 'done'){
				await this.hide(true, options.decisionType === 'cancel')
			}
		},
	},
}
